export { default } from './AdhesionAd';
